import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  Button,
  Col,
  Checkbox,
  Form,
  Input,
  Row } from 'antd';

import {
  ThemeColors,
} from '@constants/Theme';
import {
  LockOutlined,
  UserOutlined,
} from '@ant-design/icons';


const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      email: '',
      password: '',
      remember_me: true,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  handleSubmit(values) {
    this.setState({ isLoading: true });
    // Form validated successfully via onFinish — submit the HTML form
    const formEl = document.querySelector('form.login-form');
    if (formEl) formEl.submit();
  }

  onChangeText(key, e) {
    this.setState({
      [key]: e.target.value,
    })
  }

  onChangeCheckbox(key, e) {
    this.setState({
      [key]: e.target.checked,
    });
  }

  render() {
    const redirect = `/users/sign_in?${ this.props.locationState ? `redirect=${this.props.locationState.from.pathname}` : '' }`;
    return (
      <Form form={this.props.form} onFinish={this.handleSubmit} className="login-form" action={redirect} method="POST">
        <input type="hidden" name="authenticity_token" value={ csrfToken } />
        <input type="hidden" name="user[email]" value={ this.state.email } />
        <input type="hidden" name="user[password]" value={ this.state.password } />
        <input type="hidden" name="user[remember_me]" value={ this.state.remember_me ? "1" : "0" } />

        <Form.Item
          hasFeedback
         name="email" rules={[
                { required: true, message: 'Please input your email!' },
              ]}>
          <Input
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              size="large"
              placeholder="Email"
              onChange={ (e) => this.onChangeText('email', e) }
            />
        </Form.Item>
        <Form.Item
          hasFeedback
         name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
          <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              size="large"
              type="password"
              placeholder="Password"
              onChange={ (e) => this.onChangeText('password', e) }
            />
        </Form.Item>
        <Form.Item name="remember" initialValue={this.state.remember_me} valuePropName="checked">
          <Checkbox
              onChange={ (e) => this.onChangeCheckbox('remember_me', e) }
            >
              Remember me
            </Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button" loading={ this.state.isLoading }>
            Log in
          </Button>
        </Form.Item>
        <Row type="flex" justify="space-between">
          <Link to="/sign_up">Sign up</Link>
          <Link to="/forgot_password">Forgot password</Link>
        </Row>
      </Form>
    );
  }
}

const WrappedLoginForm = (props) => {
  const [form] = Form.useForm();
  return <LoginForm {...props} form={form} />;
};
class LoginScreenInner extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const locationState = this.props.location ? this.props.location.state : null
    return (
      <Row
        type="flex" justify="center" align="middle"
        style={{ height: '90%' }}
      >
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 20, offset: 0 }}
          md={{ span: 16, offset: 0 }}
          lg={{ span: 12, offset: 0 }}
          style={{
            backgroundColor: 'white',
            borderColor: ThemeColors.darkBlue,
            borderStyle: 'solid',
            borderWidth: 1,
            padding: 30,
          }}
        >
          <h2>Log in</h2>
          <WrappedLoginForm locationState={locationState} />
        </Col>
      </Row>
    )
  }
}

export default function LoginScreen(props) {
  const location = useLocation();
  return <LoginScreenInner {...props} location={location} />;
}
